import { UserResponse } from 'stream-chat';
import { ChatGenerics } from './streamTypes';

export const ProcBots = Object.freeze({
  Global: 'procursys-bot',
  FM: 'procursys-fm-bot',
  SP: 'procursys-sp-bot',
});

const BOT_IDS: string[] = [ProcBots.FM, ProcBots.SP, ProcBots.Global];

export const getIsMessageBot = (user: UserResponse<ChatGenerics>): boolean => (
  BOT_IDS.includes(user.id)
);
